import { TCFLevel } from './types';

/**
 * TCF 等级详细描述
 */
export const TCF_LEVEL_DESCRIPTIONS: Record<
  TCFLevel,
  {
    name: string;
    nameFr: string;
    description: string;
    canDo: string[];
    studyHours: string;
  }
> = {
  [TCFLevel.A1]: {
    name: '初级入门',
    nameFr: 'Élémentaire',
    description: '能够理解和使用熟悉的日常表达和非常基本的短语。',
    canDo: [
      '介绍自己和他人',
      '询问和回答关于个人细节的问题',
      '进行简单的互动，前提是对方说话缓慢清晰',
    ],
    studyHours: '约 60-100 小时',
  },
  [TCFLevel.A2]: {
    name: '初级',
    nameFr: 'Élémentaire avancé',
    description: '能够理解与个人相关领域的句子和常用表达。',
    canDo: [
      '描述自己的背景、教育和周围环境',
      '处理简单的日常任务',
      '进行简单直接的信息交流',
    ],
    studyHours: '约 150-200 小时',
  },
  [TCFLevel.B1]: {
    name: '中级',
    nameFr: 'Intermédiaire',
    description: '能够理解工作、学校、休闲等熟悉事务的要点。',
    canDo: [
      '应对旅行中可能遇到的大多数情况',
      '描述经历、事件、梦想和抱负',
      '简要地给出原因和解释',
    ],
    studyHours: '约 350-400 小时',
  },
  [TCFLevel.B2]: {
    name: '中高级',
    nameFr: 'Intermédiaire avancé',
    description: '能够理解复杂文本的主要思想，包括专业领域的技术讨论。',
    canDo: [
      '与母语者进行流利的交流',
      '就广泛的话题进行清晰详细的表达',
      '解释对时事问题的观点并说明各种选择的利弊',
    ],
    studyHours: '约 500-600 小时',
  },
  [TCFLevel.C1]: {
    name: '高级',
    nameFr: 'Supérieur',
    description: '能够理解各种要求较高的长篇文章，并识别隐含意义。',
    canDo: [
      '流利自然地表达，不明显搜寻词汇',
      '在社交、学术和专业目的中灵活有效地使用语言',
      '就复杂话题产出清晰、结构良好、详细的文本',
    ],
    studyHours: '约 700-800 小时',
  },
  [TCFLevel.C2]: {
    name: '精通级',
    nameFr: 'Supérieur avancé',
    description: '能够轻松理解几乎所有听到或读到的内容。',
    canDo: [
      '从不同来源总结信息，重建论点和叙述',
      '非常流利、精确地表达自己',
      '在复杂情况下区分细微的意义差别',
    ],
    studyHours: '约 1000+ 小时',
  },
};

/**
 * 获取等级描述
 */
export function getLevelDescription(level: TCFLevel) {
  return TCF_LEVEL_DESCRIPTIONS[level];
}

/**
 * 获取下一个等级
 */
export function getNextLevel(currentLevel: TCFLevel): TCFLevel | null {
  const levels = Object.values(TCFLevel);
  const currentIndex = levels.indexOf(currentLevel);
  if (currentIndex < levels.length - 1) {
    return levels[currentIndex + 1];
  }
  return null;
}

/**
 * 比较两个等级
 * 返回 -1 如果 a < b，0 如果 a = b，1 如果 a > b
 */
export function compareLevels(a: TCFLevel, b: TCFLevel): number {
  const levels = Object.values(TCFLevel);
  const indexA = levels.indexOf(a);
  const indexB = levels.indexOf(b);
  return Math.sign(indexA - indexB);
}
